let serverTimeOffset = 0

export function updateServerTimeOffset(serverDateStr) {
  if (serverDateStr) {
    serverTimeOffset = new Date(serverDateStr).getTime() - Date.now()
  }
  console.log('更新服务器时间：' + serverDateStr, serverTimeOffset)
}

export function getServerTimestamp() {
  console.log('获取服务器时间：' + new Date(Date.now() + serverTimeOffset))
  return Date.now() + serverTimeOffset
}
